import React, { useState } from 'react';
import classNames from 'classnames';
import PinMarker from '../../../models/PinMarker';
import Icons from '../../../utils/Icons';
import i18n from '../../../i18n';
import Analytics from '../../../utils/analytics';

const PinLegends = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const togglePopup = () => {
        Analytics.trackGTM('SearchMap', {
            event_data: { action: 'click', text: 'legend', area: 'search_page_map' }
        });
        setIsPopupOpen(!isPopupOpen);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
    };

    return (
        <div className="pin-legends-btn-container">
            <button
                onClick={togglePopup}
                className={classNames('button', {
                    hidden: isPopupOpen
                })}
            >
                <i className="icon-map-legend" />
            </button>
            <div
                className={classNames('popup', {
                    open: isPopupOpen
                })}
            >
                <i className="icon-remove" onClick={closePopup} />
                <div className="ping-legends-list">
                    {PinMarker.MAP_LEGENDS.map((item) => (
                        <div className="pin-legend-item" key={item.text}>
                            <span
                                {...(PinMarker.isFavoriteHomeIcon(item.iconClass) && {
                                    style: { fontSize: '36px' }
                                })}
                                className={item.iconClass}
                            >
                                {Icons.transform(item.iconCount)}
                            </span>
                            <p>{i18n.t(item.text)}</p>
                        </div>
                    ))}
                </div>
                <div
                    className="pin-legends-learn-more"
                    dangerouslySetInnerHTML={{
                        __html: i18n.t('home:pin-legend-container-learn-more-link')
                    }}
                />
            </div>
        </div>
    );
};

export default PinLegends;
